export default "__VITE_ASSET__3ab6aaaf__"